var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfwayToGoalUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#8d0034;stroke-linecap:round;stroke-width:3px;fill:url(#a);}.b{fill:none;}.c{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.5,
    y1: 50,
    x2: 97.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d11947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d0034"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 50,
    cy: 50,
    r: 47.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.57,46.9c-3,0-4,3.28-4,6.35s1,6.35,4,6.35c2.46,0,4-2.44,4-6.35S63,46.9,60.57,46.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.76,49.33c0-.61-.11-2.61-1.45-2.61s-1.47,2-1.47,2.61.11,2.61,1.47,2.61S72.76,49.94,72.76,49.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80.3,54.55c-1.36,0-1.46,2-1.46,2.61s.1,2.61,1.46,2.61,1.45-2,1.45-2.61S81.65,54.55,80.3,54.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.3,66.85,32.36,75.76l3.23-18.87a1.47,1.47,0,0,0-.43-1.33L21.45,42.2l19-2.75a1.5,1.5,0,0,0,1.13-.82L50,21.46l8.47,17.17a1.5,1.5,0,0,0,2.69-1.33L51.34,17.41a1.49,1.49,0,0,0-2.68,0L39.19,36.59,18,39.67a1.51,1.51,0,0,0-1.22,1,1.54,1.54,0,0,0,.38,1.54L32.5,57.16,28.89,78.25a1.48,1.48,0,0,0,.59,1.46,1.55,1.55,0,0,0,.89.29,1.53,1.53,0,0,0,.69-.17L50.7,69.5a1.5,1.5,0,1,0-1.4-2.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M47.12,50.44a6.73,6.73,0,0,0-2.86.62l.44-3.94h6.82a.5.5,0,0,0,.5-.5v-1.2a.5.5,0,0,0-.5-.5H43.13a.5.5,0,0,0-.49.44l-.94,7.72a.49.49,0,0,0,.3.52l1.08.45a.51.51,0,0,0,.54-.11,4.55,4.55,0,0,1,3.29-1.33,3.39,3.39,0,0,1,3.67,3.48,3.44,3.44,0,0,1-3.71,3.55,3.47,3.47,0,0,1-3.65-2.86.49.49,0,0,0-.21-.32.55.55,0,0,0-.37-.08l-1.3.25a.47.47,0,0,0-.32.21.49.49,0,0,0-.08.37,5.69,5.69,0,0,0,5.91,4.62A5.76,5.76,0,0,0,52.94,56,5.52,5.52,0,0,0,47.12,50.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M60.57,44.67c-3.81,0-6.37,3.45-6.37,8.58s2.56,8.58,6.37,8.58,6.36-3.45,6.36-8.58S64.37,44.67,60.57,44.67Zm0,14.93c-3,0-4-3.28-4-6.35s1-6.35,4-6.35c2.46,0,4,2.43,4,6.35S63,59.6,60.57,59.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M80.3,52.61c-2.13,0-3.52,1.79-3.52,4.55s1.39,4.55,3.52,4.55,3.53-1.82,3.53-4.55S82.41,52.61,80.3,52.61Zm0,7.16c-1.36,0-1.46-2-1.46-2.61s.1-2.61,1.46-2.61,1.45,2,1.45,2.61S81.65,59.77,80.3,59.77Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.83,49.33c0-2.72-1.42-4.55-3.52-4.55s-3.52,1.79-3.52,4.55,1.38,4.55,3.52,4.55S74.83,52.05,74.83,49.33Zm-5,0c0-.61.11-2.61,1.47-2.61s1.45,2,1.45,2.61-.11,2.61-1.45,2.61S69.84,49.94,69.84,49.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.25,45.16a.5.5,0,0,0-.43-.24H79.5a.51.51,0,0,0-.44.26L70.4,60.84a.5.5,0,0,0,0,.49.48.48,0,0,0,.43.25h1.3a.48.48,0,0,0,.43-.26l8.69-15.66A.52.52,0,0,0,81.25,45.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfwayToGoalUnlocked);
export default __webpack_public_path__ + "static/media/halfwayToGoalUnlocked.b65c3ebfc9b2b6b647e0de57ec6c3432.svg";
export { ForwardRef as ReactComponent };